/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { __decorate } from "tslib";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { soapNodeText, soapAttribute, SoapRequestData, SoapService } from "../SoapService";
export class BasicSearchParameterSet extends SoapRequestData {
}
__decorate([
    soapAttribute()
], BasicSearchParameterSet.prototype, "firstHitPosition", void 0);
__decorate([
    soapAttribute()
], BasicSearchParameterSet.prototype, "numberOfHits", void 0);
export class DisplayText extends SoapRequestData {
    constructor() {
        super();
        this.value = "";
    }
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, DisplayText.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        var _a;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tName = new DisplayText();
        tName.value = (_a = SoapService.GetSoapDataNodeValue(pSoapData)) !== null && _a !== void 0 ? _a : "";
        tName.lang = pSoapData.lang;
        return (tName);
    }
}
__decorate([
    soapNodeText()
], DisplayText.prototype, "value", void 0);
__decorate([
    soapAttribute()
], DisplayText.prototype, "lang", void 0);
export class GetPackageInfoOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "allData", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "allLanguages", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "useManufacturerConfig", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "manufacturerId", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "supplierId", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "seriesIds", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "releaseVersion", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "releaseDate", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "releaseState", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "languages", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "type", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "category", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "dependencies", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "catalogs", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "features", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "seriesType", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "priceProfileRegionId", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "specialArticleScheme", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "globalTradeItemNumber", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "maskedCatalogs", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "releaseText", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "manufacturerName", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "programName", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "distributorName", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "copyright", void 0);
__decorate([
    soapAttribute()
], GetPackageInfoOptions.prototype, "description", void 0);
export class LookupOptions extends SoapRequestData {
}
__decorate([
    soapAttribute()
], LookupOptions.prototype, "displayMode", void 0);
__decorate([
    soapAttribute()
], LookupOptions.prototype, "descriptors", void 0);
__decorate([
    soapAttribute()
], LookupOptions.prototype, "subCategories", void 0);
__decorate([
    soapAttribute()
], LookupOptions.prototype, "synonyms", void 0);
__decorate([
    soapAttribute()
], LookupOptions.prototype, "resourceValues", void 0);
__decorate([
    soapAttribute()
], LookupOptions.prototype, "resourceURLs", void 0);
export class SearchArticleParameterSet extends BasicSearchParameterSet {
}
__decorate([
    soapAttribute()
], SearchArticleParameterSet.prototype, "brandId", void 0);
__decorate([
    soapAttribute()
], SearchArticleParameterSet.prototype, "manufacturerId", void 0);
__decorate([
    soapAttribute()
], SearchArticleParameterSet.prototype, "seriesId", void 0);
__decorate([
    soapAttribute()
], SearchArticleParameterSet.prototype, "baseArticleNumber", void 0);
__decorate([
    soapAttribute()
], SearchArticleParameterSet.prototype, "varCodeType", void 0);
__decorate([
    soapAttribute()
], SearchArticleParameterSet.prototype, "variantCode", void 0);
export class SearchParameterSet extends BasicSearchParameterSet {
    constructor() {
        super();
        this.query = "";
    }
}
export class SearchResourceParameterSet extends BasicSearchParameterSet {
    constructor() {
        super();
        this.value = "";
    }
}
__decorate([
    soapAttribute()
], SearchResourceParameterSet.prototype, "catalogPackageId", void 0);
__decorate([
    soapAttribute()
], SearchResourceParameterSet.prototype, "language", void 0);
__decorate([
    soapAttribute()
], SearchResourceParameterSet.prototype, "resourceType", void 0);
////////
// response types
export class CatalogItem {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, CatalogItem.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        let tXsiType = pSoapData["xsi:type"];
        if (tXsiType == null)
            tXsiType = "";
        let tItem = null;
        if (tXsiType.indexOf("ArticleCatalogItem") > -1) {
            const tAItem = new ArticleCatalogItem();
            tAItem.articlePackageId = pSoapData.articlePackageId;
            tAItem.baseArticleNumber = pSoapData.baseArticleNumber;
            tAItem.varCodeType = pSoapData.varCodeType;
            tAItem.variantCode = pSoapData.variantCode;
            tItem = tAItem;
        }
        else {
            tItem = new CatalogItem();
        }
        tItem.catalogId = pSoapData.catalogId;
        tItem.catalogNodeKey = pSoapData.catalogNodeKey;
        tItem.catalogPackageId = pSoapData.catalogPackageId;
        tItem.label = pSoapData.label;
        tItem.icon = pSoapData.icon;
        tItem.name = pSoapData.name;
        tItem.type = pSoapData.type;
        tItem.resources = CatalogResource.FromSoapArray(pSoapData.resources);
        tItem.manufacturerIds = SoapService.SoapDataToArray(pSoapData.manufacturerIds);
        tItem.images = CatalogImage.FromSoapArray(pSoapData.images);
        return (tItem);
    }
}
export class ArticleCatalogItem extends CatalogItem {
}
export class CatalogImage {
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, CatalogImage.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tImage = new CatalogImage();
        tImage.purpose = pSoapData.purpose;
        tImage.language = pSoapData.language;
        tImage.highRes = SoapService.SoapDataToBool(pSoapData.highRes);
        tImage.width = SoapService.SoapDataToInt(pSoapData.width);
        tImage.height = SoapService.SoapDataToInt(pSoapData.height);
        tImage.name = pSoapData.name;
        tImage.url = pSoapData.url;
        return (tImage);
    }
}
export class CatalogResource {
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, CatalogResource.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tResource = new CatalogResource();
        tResource.language = pSoapData.language;
        tResource.type = pSoapData.type;
        tResource.value = pSoapData.value;
        return (tResource);
    }
}
export class MaskedCatalog {
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, MaskedCatalog.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tCat = new MaskedCatalog();
        tCat.moduleKey = pSoapData.moduleKey;
        tCat.version = pSoapData.version;
        return (tCat);
    }
}
export class PackageInfo {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, PackageInfo.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tInfo = new PackageInfo();
        tInfo.manufacturerId = pSoapData.manufacturerId;
        tInfo.supplierId = pSoapData.supplierId;
        tInfo.releaseVersion = pSoapData.releaseVersion;
        tInfo.releaseDate = pSoapData.releaseDate;
        tInfo.releaseState = pSoapData.releaseState;
        tInfo.type = pSoapData.type;
        tInfo.category = pSoapData.category;
        tInfo.seriesType = pSoapData.seriesType;
        tInfo.priceProfileRegionId = pSoapData.priceProfileRegionId;
        tInfo.specialArticleScheme = pSoapData.specialArticleScheme;
        tInfo.globalTradeItemNumber = pSoapData.globalTradeItemNumber;
        tInfo.packageId = pSoapData.packageId;
        //handle extra array wrappers
        tInfo.seriesIds = SoapService.SoapDataToArray((_a = pSoapData.seriesIds) === null || _a === void 0 ? void 0 : _a.seriesId);
        tInfo.languages = SoapService.SoapDataToArray((_b = pSoapData.languages) === null || _b === void 0 ? void 0 : _b.language);
        tInfo.dependencies = PackageDependency.FromSoapArray((_c = pSoapData.dependencies) === null || _c === void 0 ? void 0 : _c.dependency);
        tInfo.catalogs = SoapService.SoapDataToArray((_d = pSoapData.catalogs) === null || _d === void 0 ? void 0 : _d.catalog);
        tInfo.features = SoapService.SoapDataToArray((_e = pSoapData.features) === null || _e === void 0 ? void 0 : _e.feature);
        tInfo.maskedCatalogs = MaskedCatalog.FromSoapArray((_f = pSoapData.maskedCatalogs) === null || _f === void 0 ? void 0 : _f.maskedCatalog);
        tInfo.releaseText = DisplayText.FromSoapArray((_g = pSoapData.releaseText) === null || _g === void 0 ? void 0 : _g.text);
        tInfo.manufacturerName = DisplayText.FromSoapArray((_h = pSoapData.manufacturerName) === null || _h === void 0 ? void 0 : _h.text);
        tInfo.programName = DisplayText.FromSoapArray((_j = pSoapData.programName) === null || _j === void 0 ? void 0 : _j.text);
        tInfo.distributorName = DisplayText.FromSoapArray((_k = pSoapData.distributorName) === null || _k === void 0 ? void 0 : _k.text);
        tInfo.copyright = DisplayText.FromSoapArray((_l = pSoapData.copyright) === null || _l === void 0 ? void 0 : _l.text);
        tInfo.description = DisplayText.FromSoapArray((_m = pSoapData.description) === null || _m === void 0 ? void 0 : _m.text);
        return (tInfo);
    }
}
export class PackageDependency {
    static FromSoapArray(pSoapArray) {
        return (SoapService.SoapDataToArray(pSoapArray, PackageDependency.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tDep = new PackageDependency();
        tDep.packageId = pSoapData.packageId;
        tDep.version = pSoapData.version;
        return (tDep);
    }
}
export class ScoredCatalogItem {
    static FromSoapArrayNU(pSoapArray) {
        return (SoapService.SoapDataToArrayNU(pSoapArray, ScoredCatalogItem.FromSoapNU));
    }
    static FromSoapNU(pSoapData) {
        if (pSoapData == null)
            throw new Error(ERR_INVALID_ARGUMENT);
        const tItem = new ScoredCatalogItem();
        tItem.item = CatalogItem.FromSoapNU(pSoapData.item);
        tItem.score = SoapService.SoapDataToFloat(pSoapData.score);
        return (tItem);
    }
}
export class TopCatalogItems {
    static FromSoap(pSoapData) {
        if (pSoapData == null)
            return (undefined);
        const tItems = new TopCatalogItems();
        tItems.scoredItems = ScoredCatalogItem.FromSoapArrayNU(pSoapData.scoredItems);
        tItems.totalHits = SoapService.SoapDataToInt(pSoapData.totalHits);
        return (tItems);
    }
}
